import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-whitepaper-container',
  imports: [CommonModule,RouterModule],
  standalone:true,
  templateUrl: './whitepaper-container.component.html',
  styleUrl: './whitepaper-container.component.scss'
})
export class WhitepaperContainerComponent {

}
